import type { Validator } from "webApp";

const getMessage = (rule: string, arg: string | number = ''): string => {
  const message = {
    required: 'Required',
    length: `Must be ${arg} characters or more`,
    alpha: 'Only alphabet characters',
    alphaNumeric: 'Only alphanumeric characters',
    alphaDash: 'Only alphabet or dash characters',
    number: 'Must be a number',
    postalCode: 'Must be a valid zip code',
    email: 'Invalid email address',
    phoneNumber: 'Invalid phone number, must be 10 digits',
    minValue: `Must be at least ${arg}`,
    maxValue: `Must be at most ${arg}`,
    maxAge: 'Must be a valid age.',
    datetime: 'Must be a valid date/time'
  };
  return message[rule];
};

// prettier-ignore
const results: { [key in any]?: Validator } = {
  required: value => value ? undefined : getMessage('required'),
  maxLength: max => value => value && value.length > max ? getMessage('length', max) : undefined,
  minLength: min => value => value && value.length < min ? getMessage('length', min) : undefined,
  exactLength: length => value => value && value.length !== length ? getMessage('length', length) : undefined,
  alpha: value => value && /[^a-zA-ZÀ-ÿŸœ ]/i.test(value) ? getMessage('alpha') : undefined,
  alphaDash: value => value && /[^a-zA-ZÀ-ÿŸœ_\- ]/i.test(value) ? getMessage('alphaDash') : undefined,
  alphaNumeric: value => value && /[^a-zA-Z0-9À-ÿŸœ ]/i.test(value) ? getMessage('alphaNumeric') : undefined,
  number: value => value && Number.isNaN(Number(value)) ? getMessage('number') : undefined,
  postalCode: value => value && !/^\d{5}$/.test(value) ? getMessage('postalCode') : undefined,
  email: value => value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? getMessage('email') : undefined,
  phoneNumber: value => value && !/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/i.test(value) ? getMessage('phoneNumber') : undefined,
  maxAge: max => value => value && value > max ? getMessage('maxAge', max) : undefined,
  minValue: min => value => value && value < min ? getMessage('minValue', min) : undefined,
  maxValue: max => value => value && value > max ? getMessage('maxValue', max) : undefined,
  datetime: value => Number.isNaN(Date.parse(value)) ? getMessage('datetime') : undefined
};
export default results;
export const composeValidators = (...validators: Array<Validator>) => (value: string | null | undefined) => validators.reduce((error, validator) => error || validator(value), undefined);